import React, { useEffect, useState } from "react";
import CommonForm from "../../../../../../components/commonform/commonForm";
import "./style.css";
import { common_file_upload, user_locations_list } from "../../../../user.api";
export default function OwnLand(props) {
  // const [formvalues, setFormValues] = useState(props.formvalues);
  const [formvalues, setFormValues] = useState([{ name: "tvm" }]);
  const [isActive, setIsActive] = useState(false);
  const [baseLocation, setBaseLocation] = useState([]);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const handleChange = (e) => {
    const selectedId = parseInt(e.target.value); // Ensure it's a number
    const loc = props.data.find((a) => a.id === selectedId);

    const data = {
      ...formvalues[0],
      [e.target.name]: selectedId,
      location: loc?.locations || "",
    };

    const datas = [{ ...data }];
    setFormValues(datas);

    setTimeout(() => {
      props.handleFormData(datas);
    }, 100);
  };

  const getLocationList = () => {
    setIsActive(true);
    user_locations_list().then((res) => {
      setBaseLocation(res.data);
      setIsActive(false);
    });
  };

  const handleChangeArea = (e) => {
    const selectedValue = e.target.value;

    const data = {
      ...formvalues[0],
      [e.target.name]: selectedValue,
    };

    const datas = [{ ...data }];
    setFormValues(datas);

    setTimeout(() => {
      props.handleFormData(datas);
    }, 100);
  };

  const handleChangeInterest = (e) => {
    const selectedValue = e.target.value;

    const data = {
      ...formvalues[0],
      [e.target.name]: selectedValue,
      interest: selectedValue,
    };

    const datas = [{ ...data }];
    setFormValues(datas);

    setTimeout(() => {
      props.handleFormData(datas);
    }, 100);
  };

  useEffect(() => {
    getLocationList();
  }, []);
  const handleText = (e, item) => {
    let data = {};

    data = {
      ...formvalues[0],
      [e.target.name]: e.target.value,
    };
    let datas = [{ ...data }];
    setFormValues(datas);
    setTimeout(() => {
      props.handleFormData(datas);
    }, 100);
  };
  const handleNumber = (e, item) => {
    var validNumber = new RegExp(/^\d*\.?\d*$/);
    if (validNumber.test(e.target.value)) {
      let data = {};

      data = {
        ...formvalues[0],
        [e.target.name]: e.target.value,
      };
      let datas = [{ ...data }];
      setFormValues(datas);
      setTimeout(() => {
        props.handleFormData(datas);
      }, 100);
    }
  };

  const eduUploadFile = (e) => {
    let data = e.target.files[0];

    const file = new FormData();
    file.append("file", data);
    file.append("type", "companies/proposals");

    setIsActive(true);

    common_file_upload(file)
      .then((res) => {
        const updated = [...formvalues];
        updated[0] = {
          ...updated[0],
          proposal_file: res?.data ?? "",
          file_name: data.name ?? "",
        };
        setFormValues(updated);

        // Optionally pass to parent
        setTimeout(() => {
          props.handleFormData(updated);
        }, 100);

        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage("Something went wrong");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const handleEducationalFileChange = (e) => {
    let size = e.target.files[0].size;
    let type = e.target.files[0].name.split(".").pop();

    if (type?.toLowerCase() === "pdf") {
      let mb = size / Math.pow(1024, 2);
      if (mb < 1) {
        eduUploadFile(e);
      } else {
        setSnackMessage("File size is greater than 1MB");
        setIsSnackError(true);
        setSnackOpen(true);
      }
    } else {
      setSnackMessage("File should be .pdf format");
      setIsSnackError(true);
      setSnackOpen(true);
    }
  };

  return (
    <div className="ownlad">
      <div>Enter Premises Details</div>

      <div className="table-container">
        <React.Fragment>
          <table className="table-bordered">
            <tbody>
              <tr>
                <td className="bg-col pb-4">
                  <div className="row mx-2">
                    <div className=" col-md-12 col-sm-12">
                      <div className="row mt-2">
                        <div className="ownd col-6">
                          <div className="">
                            <label className={"control-label mylabel mb-2"}>
                              Location
                            </label>
                          </div>
                          <select
                            id="location"
                            className="form-select selectbox w-100"
                            required
                            disabled={props.disabled}
                            name="location_id"
                            onChange={handleChange}
                            value={formvalues[0]?.location_id ?? ""}
                          >
                            <option value="">Select a location</option>
                            {baseLocation.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.locations}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="ownd col-6">
                          <CommonForm
                            fieldType="text"
                            onChange={(e) => handleText(e)}
                            disabled={props.disabled}
                            label="Sub Location"
                            value={formvalues[0]?.sub_location ?? ""}
                            name="sub_location"
                            required
                          />
                        </div>
                      </div>

                      {/* <div className="row mt-3">
                        <div className="ownd col-md-6 col-sm-12 ">
                          <div>
                            <CommonForm
                              fieldType="text"
                              onChange={(e) => handleNumber(e)}
                              disabled={props.disabled}
                              label="Available Area  in sq.ft"
                              value={formvalues[0]?.area_in_sqft ?? ""}
                              name="area_in_sqft"
                              required
                            />
                          </div>
                        </div>

                        <div className="ownd col-md-6 col-sm-12">
                         
                          <div className="">
                            <div className="control-label mylabel">
                              Nature of holding
                            </div>
                            <select
                              required
                              name="nature_of_holding"
                              disabled={props.disabled}
                              onChange={(e) => handleText(e)}
                              value={formvalues[0]?.nature_of_holding ?? ""}
                              id="nature_of_holding"
                              className="form-select selectbox w-100"
                            >
                              <option value=""></option>

                              <option value="Full-Ownersip">
                                Full-Ownersip
                              </option>
                              <option value="Joint Ownership">
                                Joint Ownership
                              </option>
                              <option value="Leased Line">Leased Line</option>
                            </select>
                          </div>
                        </div>
                      </div> */}
                    </div>

                    <div className="ownd col-6">
                      <CommonForm
                        fieldType="text"
                        onChange={(e) => handleText(e)}
                        disabled={props.disabled}
                        label="Survey no"
                        value={formvalues[0]?.survey_no ?? ""}
                        name="survey_no"
                        required
                      />
                    </div>
                    <div className="ownd col-6">
                      <CommonForm
                        fieldType="text"
                        onChange={(e) => handleText(e)}
                        disabled={props.disabled}
                        label="Block No"
                        value={formvalues[0]?.block_no ?? ""}
                        name="block_no"
                        required
                      />
                    </div>
                    <div className="ownd col-6">
                      <CommonForm
                        fieldType="text"
                        onChange={(e) => handleText(e)}
                        disabled={props.disabled}
                        label="Village Name"
                        value={formvalues[0]?.village_name ?? ""}
                        name="village_name"
                        required
                      />
                    </div>
                    <div className="ownd col-6"></div>

                    <div className="ownd col-6">
                      <CommonForm
                        fieldType="text"
                        multiline
                        onChange={(e) => handleText(e)}
                        disabled={props.disabled}
                        label="Address of the property"
                        value={formvalues[0]?.land_address ?? ""}
                        name="land_address"
                        required
                      />
                    </div>
                    <div className="ownd col-6">
                      <CommonForm
                        fieldType="text"
                        multiline
                        onChange={(e) => handleText(e)}
                        disabled={props.disabled}
                        label="Management Plan"
                        value={formvalues[0]?.management_plan ?? ""}
                        name="management_plan"
                      />
                    </div>
                    <div className="ownd col-6">
                      <div className="">
                        <label className={"control-label mylabel mb-2"}>
                          Nature of Holding
                        </label>
                      </div>
                      <select
                        id="nature_of_holding"
                        className="form-select selectbox w-100 mandatory-select"
                        required
                        disabled={props.disabled}
                        name="nature_of_holding"
                        onChange={handleChangeArea}
                        value={formvalues[0]?.nature_of_holding ?? ""}
                      >
                        <option value="">Select a nature of holding</option>
                        <option key="built_up_space" value="Built-up Space">
                          Built-up Space
                        </option>
                        <option key="land_on" value="Land">
                          Land
                        </option>
                      </select>
                    </div>
                    {formvalues[0]?.nature_of_holding == "Built-up Space" ? (
                      <div className="ownd col-6">
                        <CommonForm
                          fieldType="text"
                          onChange={(e) => handleText(e)}
                          disabled={props.disabled}
                          label="Built-up Space Area"
                          value={formvalues[0]?.area_in_sqft ?? ""}
                          name="area_in_sqft"
                        />
                      </div>
                    ) : (
                      formvalues[0]?.nature_of_holding == "Land" && (
                        <div className="ownd col-6">
                          <CommonForm
                            fieldType="text"
                            onChange={(e) => handleText(e)}
                            disabled={props.disabled}
                            label="Area in Acre"
                            value={formvalues[0]?.area_in_sqft ?? ""}
                            name="area_in_sqft"
                            required
                          />
                        </div>
                      )
                    )}
                    <div className="ownd col-6">
                      <div className="">
                        <label className={"control-label mylabel mb-2"}>
                          Are you interested in Joint venture with KSPACE ?
                        </label>
                      </div>
                      <select
                        id="interest"
                        className="form-select selectbox w-100 mandatory-select"
                        required
                        disabled={props.disabled}
                        name="interest"
                        onChange={handleChangeArea}
                        value={formvalues[0]?.interest ?? ""}
                      >
                        <option value="">Select an interest</option>
                        <option key="yes" value="yes">
                          Yes
                        </option>
                        <option key="no" value="no">
                          No
                        </option>
                      </select>
                    </div>
                    {formvalues[0]?.interest === "yes" && (
                      <div className="col-12">
                        <CommonForm
                          fieldType="file"
                          label="Upload the proposal"
                          name="file_upload_certificate"
                          {...props}
                          id="file_upload_certificate"
                          className="no-margin"
                          accept=".pdf"
                          type="file"
                          variant="outlined"
                          fileName={formvalues[0]?.file_name}
                          //filename={e?.file_name}
                          // onChange={handleFileChange}
                          onChange={(e) => {
                            handleEducationalFileChange(e);
                          }}
                        />
                        <div className="file-up-helper">
                          *Upload only .pdf format and Size should be less than
                          1MB
                        </div>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </React.Fragment>
      </div>
    </div>
  );
}
